// @ts-check
/* global umami */

/**
 * Store timestamp from DOMContentLoaded
 */
let domLoaded;
window.addEventListener("DOMContentLoaded", (e) => (domLoaded = e.timeStamp));
window.addEventListener("load", (e) => browserEnvironment(e));

/**
 * @param {Event} event
 */
function browserEnvironment(event) {
  const data = {
    pathname: window.location.pathname,
    title: document.title,
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    screenOrientation: window.screen.orientation.type,
    screenAngle: window.screen.orientation.angle,
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight,
    devicePixelRatio: window.devicePixelRatio,
    domReady: Math.round(domLoaded),
    load: Math.round(event.timeStamp),
  };
  console.log({ browserEnvironment: data });

  if (window.umami && umami.track) {
    umami.track("browserEnvironment", { data });
  }
}
